//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import tags from "./tags";
import search from "./search";
import top from "./top/";
import sidebar from "./sidebar/";
import admin from "@/util/admin";
import { validatenull } from "@/util/validate";
import { calcDate } from "@/util/date.js";
import { getStore } from "@/util/store.js";
import { info } from "@/api/system/tenant";
import { getTopUrl } from "@/util/util";
export default {
  components: {
    top: top,
    tags: tags,
    search: search,
    sidebar: sidebar
  },
  name: "index",
  provide: function provide() {
    return {
      index: this
    };
  },
  data: function data() {
    return {
      //搜索控制
      isSearch: false,
      //刷新token锁
      refreshLock: false,
      //刷新token的时间
      refreshTime: ""
    };
  },
  created: function created() {//实时检测刷新token
    // this.refreshToken();
  },
  mounted: function mounted() {
    this.init();
    this.getTenant();
  },
  computed: mapGetters(["isMenu", "isLock", "isCollapse", "website", "menu"]),
  props: [],
  methods: {
    getTenant: function getTenant() {
      var _this = this;

      var domain = getTopUrl(); // 临时指定域名，方便测试
      //domain = "https://bladex.vip";

      info(domain).then(function (res) {
        var data = res.data;

        if (data.success && data.data.tenantId) {
          _this.$refs.top.companyTitle = data.data.companyTitle;
          _this.$refs.sidebar.$children[0].compayTitle = data.data.companyLogo;
          _this.$refs.sidebar.$children[0].companyName = data.data.companyTitle;
          console.log(_this, data.data, '---');
        }
      });
    },
    showCollapse: function showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    // 初始化
    init: function init() {
      var _this2 = this;

      this.$store.commit("SET_SCREEN", admin.getScreen());

      window.onresize = function () {
        setTimeout(function () {
          _this2.$store.commit("SET_SCREEN", admin.getScreen());
        }, 0);
      };

      this.$store.dispatch("FlowRoutes").then(function () {});
      this.$store.dispatch("GetwayList");
    },
    //打开菜单
    openMenu: function openMenu() {
      var _this3 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$store.dispatch("GetMenu", item.id).then(function (data) {
        if (data.length !== 0) {
          _this3.$router.$avueRouter.formatRoutes(data, true);
        } //当点击顶部菜单后默认打开第一个菜单

        /*if (!this.validatenull(item)) {
          let itemActive = {},
            childItemActive = 0;
          if (item.path) {
            itemActive = item;
          } else {
            if (this.menu[childItemActive].length === 0) {
              itemActive = this.menu[childItemActive];
            } else {
              itemActive = this.menu[childItemActive].children[childItemActive];
            }
          }
          this.$store.commit('SET_MENU_ID', item);
          this.$router.push({
            path: this.$router.$avueRouter.getPath({
              name: (itemActive.label || itemActive.name),
              src: itemActive.path
            }, itemActive.meta)
          });
        }*/

      });
    },
    // 定时检测token
    refreshToken: function refreshToken() {
      var _this4 = this;

      this.refreshTime = setInterval(function () {
        var token = getStore({
          name: "token",
          debug: true
        }) || {};
        var date = calcDate(token.datetime, new Date().getTime());
        console.log(date.seconds, _this4.website.tokenTime);
        if (validatenull(date)) return;

        if (date.seconds >= _this4.website.tokenTime && !_this4.refreshLock) {
          _this4.refreshLock = true;

          _this4.$store.dispatch("refreshToken").then(function () {
            _this4.refreshLock = false;
          }).catch(function () {
            _this4.refreshLock = false;
          });
        }
      }, 10000);
    }
  }
};